<footer class="footer border-top">
  <div class="container">
    <div class="row justify-content-center" style="color: white;">
      <div class="col-md-6">
        <div style="color: white;">
          <p><b>Copyright © 2024, Quidos Ltd. All rights reserved.</b></p>
          <div class="small">
            <p>Registered company address: 9-10 Bath Street, Bath, BA1 1SN.<br>
              Registered in England: 05665301 VAT: 879320885</p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="small" style="color: white;">
          <p>
            <a style="color: white;" target="_blank"
              href="https://quidos.co.uk/resource-centre-for-energy-assessors/">Terms and Conditions</a> |
            <a style="color: white;" target="_blank" href="https://quidos.co.uk/privacy/">Privacy Policy</a> |
            <a style="color: white;" target="_blank"
              href="https://quidos.co.uk/resource-centre-for-energy-assessors/">Disclaimer</a> |
            <a style="color: white;" target="_blank"
              href="https://quidos.co.uk/resource-centre-for-energy-assessors/">Complaints Procedure</a> |
            <a style="color: white;" target="_blank"
              href="https://quidos.co.uk/resource-centre-for-energy-assessors/">Equal Opportunities</a>
          </p>
          <div class="text-right">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <p id="api-data-trigger" class="non-selectable" style="cursor: pointer; margin: 0;">
                {{ version }} <br> Build: {{ info?.buildInfo?.number }}
              </p>
              <p id="api-status" class="hidden" style="margin: 0;">
                <em>API Status:</em>
                <span class="status-bg" [ngClass]="{'text-success': isStatusUp(), 'text-danger': !isStatusUp()}">
                  {{health?.status}}
                </span>
              </p>
            </div>
          </div>
          <div id="api-details-data" class="hidden" style="margin-top: 10px;">
            <div style="display: flex; justify-content: space-between;">
              <div class="text-start">
                <p><em>API Name: </em> <span class="border-bottom">{{info?.app?.name}}</span></p>
              </div>
              <div class="text-end">
                <p><em>API Version: </em> <span class="border-bottom">{{info?.app?.version}}</span></p>
              </div>
            </div>
            <div style="width: 100%; display: flex; justify-content: center; margin-top: 10px;">
              <p><em >API Host: </em> <span class="border-bottom">{{env?.baseApiUrl}}</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>